import { trace } from 'rytm-helpers'
import View from './View'
import { TweenMax, TimelineMax, Power0, Power1, Power2, Power3, Power4, Back, Bounce, Elastic, Expo, Sine } from 'gsap'


class HomeMainView extends View {

  constructor(id) {
    super(id)
  }
  /**
  * animate in (show)
  **/  
  show(container) {
    super.show(container)
    TweenMax.killTweensOf(container)
    TweenMax.set(container, {opacity: 0})
    TweenMax.to(container, .8, {opacity: 1, ease: Power3.easeOut, delay: .3})
  }
  /**
  * animate out (hide)
  **/
  hide(container) {
    super.hide(container)
    TweenMax.killTweensOf(container)
    TweenMax.to(container, .4, {opacity: 0, delay: .3, ease: Power3.easeIn})
  }

}

export default HomeMainView